import React from 'react';
import { ArrowRight } from 'lucide-react';
import { heroContent } from '@/data/mock';
import { Button } from '@/components/ui/button';

const HeroSection = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-[70vh] md:min-h-[80vh] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-background/30 via-background/40 to-background/70 z-10" />
        <img
          src={heroContent.backgroundImage}
          alt="Indian Artisan Craftsmanship"
          className="w-full h-full object-cover opacity-80 dark:opacity-70"
        />
      </div>

      {/* Content */}
      <div className="container relative z-20 px-4 lg:px-8 py-20">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Headline */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight animate-in fade-in slide-in-from-bottom-4 duration-1000">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-foreground via-foreground/90 to-foreground/80">
              {heroContent.headline}
            </span>
          </h1>

          {/* Subtext */}
          <p className="text-base sm:text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed animate-in fade-in slide-in-from-bottom-5 duration-1000 delay-150 px-4">
            {heroContent.subtext}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 animate-in fade-in slide-in-from-bottom-6 duration-1000 delay-300 px-4">
            {heroContent.ctas.map((cta) => (
              <Button
                key={cta.id}
                onClick={scrollToContact}
                variant={cta.primary ? 'default' : 'outline'}
                size="lg"
                className={`group w-full sm:min-w-[200px] ${
                  cta.primary
                    ? 'bg-foreground text-background hover:bg-foreground/90 dark:bg-amber-600 dark:hover:bg-amber-700'
                    : ''
                }`}
              >
                {cta.text}
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
